export default __webpack_public_path__ + "static/media/gcode.1c11a33a.svg";